export const CErrorPaymentLinkContext = {
    PAYMENT_LINK_INFORMATION_ID: 'PAYMENT_LINK_INFORMATION_ID',
    PAYMENT_LINK_FEES: 'PAYMENT_LINK_FEES',
    PAYMENT_LINK_CREATE_CHECKOUT_LINK: 'PAYMENT_LINK_CREATE_CHECKOUT_LINK',
    PAYMENT_LINK_OUTCOME: 'PAYMENT_LINK_OUTCOME'
} as const;